// Передаваемый в админку ховер для баннера
(function () {
    const $bannerLinks = $('.js-help-banner-link');

    if (!$bannerLinks.length) {
        return false;
    }

    $bannerLinks.each(function (index, link) {
        $(link).mousemove(function () {
            changeBgInBtn($(this).find('.js-btn-help-banner'), 'data-bg-hover');
            changeTextInBtn(
                $(this).find('.js-btn-help-banner'),
                'data-text-color-hover'
            );
        }).mouseleave(function () {
            changeBgInBtn($(this).find('.js-btn-help-banner'), 'data-bg');
            changeTextInBtn(
                $(this).find('.js-btn-help-banner'),
                'data-text-color'
            );
        });
    });

    function changeBgInBtn($bannerBtn, attrCss) {
        $bannerBtn.css('background', $bannerBtn.attr(attrCss));
    }

    function changeTextInBtn($bannerBtn, attrCss) {
        $bannerBtn.css('color', $bannerBtn.attr(attrCss));
    }
})();



// WEBPACK FOOTER //
// ./_src/js/HelpBanner.js